import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
<footer class="footer">
  TM  &  ©  2014–${ctx.year} ${until(ctx.__('<tt-xlhFarjg>', 'Age of Learning, Inc.'))}
  <br class="d-none d-lg-none d-xs-block">
  ${until(ctx.__('<tt-NKjc5zwd>', 'All rights reserved.'))}
  <a href="https://www.ageoflearning.com/mastery_privacy" target="_blank">
    ${until(ctx.__('<tt-AXIx/w+r>', 'Privacy Policy'))}
  </a>
</footer>
`;
